import { render, staticRenderFns } from "./PODocViewer.vue?vue&type=template&id=7ba89f91&"
import script from "./PODocViewer.vue?vue&type=script&lang=js&"
export * from "./PODocViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports